export const firebaseConfig = {
    apiKey: "AIzaSyCIIKGekohgs2HP9qeXKKzjgMk_WlmiCIM",
    authDomain: "unops-infraigss-prod.firebaseapp.com",
    projectId: "unops-infraigss-prod",
    storageBucket: "unops-infraigss-prod.firebasestorage.app",
    messagingSenderId: "1003974699275",
    appId: "1:1003974699275:web:049e691ba7e34723dbda0e"
};